import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { track } from "../utils/tracking"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { useTranslation } from "react-i18next"
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';


export default function Disclaimer() {

  const [isOpen, setIsOpen] = useState(false);

  const expandedIconRotation = isOpen ? 180 : 0
  const { t } = useTranslation()

  const styles = makeStyles(theme => ({
    sectionWrapper: {
      marginTop: '0px',
    },
    expandedIcon: {
      transform: `rotate(${expandedIconRotation}deg)`,
      transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      color: "rgba(0, 0, 0, 0.54)",
      marginRight: "0.5rem",
    },
    exampleSection: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
    expandButton: {
      paddingLeft: 0,
      textAlign: "left",
      color: "#0000FF",
      textDecorationLine: "underline",
    },
    icon: {
      marginLeft: theme.spacing(1),
    }
  }))
  const classes = styles({})

  return (
    <>
      <div
        css={`
            font-size:16px;
            color:#2E2E38;
            margin-top:12px;
            text-align: justify;
        `}>
        <div className={classes.sectionWrapper}>
          <div>
            <Button variant="text" className={classes.expandButton}
              onClick={() => {
                track("user click " + t('disclaimer_info'))
                setIsOpen(!isOpen)
              }}>
              {t('disclaimer')}
              {isOpen ? <RemoveIcon className={classes.icon} /> : <AddIcon className={classes.icon} />}
            </Button>
          </div>
          {isOpen && <div className={classes.exampleSection}>{t('disclaimer_info')}</div>}
        </div>
      </div>
    </>
  )
}